import { useMemo } from 'react';

import Styles from './index.module.scss';

import { IosSpinner } from '@/components/Elements/IosSpinner';

interface Props {
	state?: 'loading' | 'no-data' | 'error';
	children?: string;
}

export const WidgetPlaceholder = ({ state = 'loading', children }: Props) => {
	const content = useMemo(() => {
		switch (state) {
			case 'loading':
				return <IosSpinner size="3.125rem" duration={1.2} />;
			case 'no-data':
				return (
					<div className={`${Styles.noData}`}>
						<span>{children ?? 'No Data'}</span>
					</div>
				);
			case 'error':
				return (
					<div className={Styles.error}>
						<p>!</p>
					</div>
				);
			default:
				return null;
		}
	}, [children, state]);

	return <div className={`${Styles.container}`}>{content}</div>;
};
